import markExternalLinks from 'mark-external-links'

markExternalLinks()
